import { Contract, ethers, JsonRpcSigner, parseUnits, Signer } from 'ethers';
import {getEthereum} from "../../contract";

export const USDC_DECIMALS = 6;
export const CDK_DECIMALS = 18;

export class BaseContract {

    contract: Contract;
    address: string = '';
    
    constructor (contract: Contract) {
        this.contract = contract;
        this.setAddress();
    }

    _getSignedContract = async (): Promise<Contract> => {
        const signer = await this.connectToMetaMask();
        return this.contract.connect(signer) as Contract;
    }

    _getSignedContractWithSigner = async (signer: Signer): Promise<Contract> => {
        return this.contract.connect(signer) as Contract;
    }

    connectToMetaMask = async (): Promise<JsonRpcSigner> => {
        try {
            const ethereum = getEthereum();
            if (!ethereum) {
                throw new Error('MetaMask not found. Please install MetaMask.');
            }
            
            const provider = new ethers.BrowserProvider(ethereum);
            
            // Check if already connected
            const accounts = await provider.send("eth_accounts", []);
            if (accounts.length === 0) {
                // Request connection
                await provider.send("eth_requestAccounts", []);
            }
            
            return provider.getSigner();
        } catch (error: any) {
            console.error('Failed to connect to MetaMask:', error);
            throw new Error(`MetaMask connection failed: ${error.message}`);
        }
    };

    setAddress = async (): Promise<void> => {
        this.address = await this.contract.getAddress();
    }
}
